var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _use, _use2, _use3, _use4, _use5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySpaceAc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "31px",
    height: "24px",
    viewBox: "0 0 31 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.239216,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(56.862745%,61.960784%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 0.300781 11.601562 C 0.300781 10.273438 1.375 9.199219 2.699219 9.199219 L 28.300781 9.199219 C 29.625 9.199219 30.699219 10.273438 30.699219 11.601562 L 30.699219 21.199219 C 30.699219 22.527344 29.625 23.601562 28.300781 23.601562 L 2.699219 23.601562 C 1.375 23.601562 0.300781 22.527344 0.300781 21.199219 Z M 0.300781 11.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.478431,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(56.862745%,61.960784%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 4.5 13.601562 L 8.898438 13.601562 C 9.453125 13.601562 9.898438 14.046875 9.898438 14.601562 C 9.898438 15.152344 9.453125 15.601562 8.898438 15.601562 L 4.5 15.601562 C 3.949219 15.601562 3.5 15.152344 3.5 14.601562 C 3.5 14.046875 3.949219 13.601562 4.5 13.601562 Z M 4.5 13.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.239216,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(56.862745%,61.960784%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 4.5 17.199219 L 15.300781 17.199219 C 15.851562 17.199219 16.300781 17.648438 16.300781 18.199219 C 16.300781 18.753906 15.851562 19.199219 15.300781 19.199219 L 4.5 19.199219 C 3.949219 19.199219 3.5 18.753906 3.5 18.199219 C 3.5 17.648438 3.949219 17.199219 4.5 17.199219 Z M 4.5 17.199219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.239216,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(56.862745%,61.960784%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 6.300781 0.398438 L 24.699219 0.398438 C 26.6875 0.398438 28.300781 2.011719 28.300781 4 C 28.300781 5.988281 26.6875 7.601562 24.699219 7.601562 L 6.300781 7.601562 C 4.3125 7.601562 2.699219 5.988281 2.699219 4 C 2.699219 2.011719 4.3125 0.398438 6.300781 0.398438 Z M 6.300781 0.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.478431,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(56.862745%,61.960784%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 6.277344 2.601562 C 6.925781 2.601562 7.453125 3.128906 7.453125 3.777344 C 7.453125 4 7.390625 4.207031 7.28125 4.386719 L 7.816406 4.921875 C 7.925781 5.03125 7.925781 5.210938 7.816406 5.320312 C 7.710938 5.425781 7.542969 5.429688 7.433594 5.328125 L 7.421875 5.320312 L 6.886719 4.78125 C 6.707031 4.890625 6.5 4.953125 6.277344 4.953125 C 5.625 4.953125 5.101562 4.425781 5.101562 3.777344 C 5.101562 3.128906 5.625 2.601562 6.277344 2.601562 Z M 6.277344 3.160156 C 5.9375 3.160156 5.660156 3.4375 5.660156 3.777344 C 5.660156 4.117188 5.9375 4.394531 6.277344 4.394531 C 6.441406 4.394531 6.597656 4.328125 6.710938 4.210938 C 6.828125 4.097656 6.890625 3.941406 6.890625 3.777344 C 6.890625 3.4375 6.617188 3.160156 6.277344 3.160156 Z M 6.277344 3.160156 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(56.862745%,61.960784%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 10.898438 3 L 20.101562 3 C 20.652344 3 21.101562 3.449219 21.101562 4 C 21.101562 4.550781 20.652344 5 20.101562 5 L 10.898438 5 C 10.347656 5 9.898438 4.550781 9.898438 4 C 9.898438 3.449219 10.347656 3 10.898438 3 Z M 10.898438 3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySpaceAc);
export default __webpack_public_path__ + "static/media/empty_space_ac.259254694eb8267d3c9fad8c58290f0c.svg";
export { ForwardRef as ReactComponent };